import ViewSongPart from './ViewSongPart';

export default ViewSongPart;
